/* ------------------------------------------------------------------
 * PINKYPACT – Konfetti nach "Auswahl übernehmen" im Bundle Builder
 *
 * Hängt sich per Event-Delegation an den Confirm-Button des Bundle-
 * Drawers. Kein Eingriff in bundle-builder.liquid nötig.
 * Respektiert prefers-reduced-motion.
 *
 * >>> TESTMODUS: Cooldown steht auf 10 Sekunden.
 * >>> VOR DEM LAUNCH zurück auf 10 * 60 * 1000 (10 Minuten) setzen.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (window.__ppConfetti) return;
  window.__ppConfetti = true;

  /* Falls der Button mal einen eigenen Selektor bekommt, hier eintragen. */
  var CONFIRM_SELECTOR = '[data-bundle-confirm], [data-drawer-confirm], [data-bundle-apply]';

  /* Fallback: Buttons mit diesem Beschriftungstext (klein geschrieben). */
  var CONFIRM_LABELS = ['auswahl übernehmen', 'auswahl uebernehmen'];

  var COLORS = ['#83374a', '#a12944', '#e3c9d2', '#f1eaeb', '#ffffff'];
  var DELAY = 320;          /* wartet, bis der Drawer zu ist */
  var COOLDOWN = 10 * 1000; /* TEST: 10 Sekunden – Produktivwert: 10 * 60 * 1000 */
  var STORE_KEY = 'pp_confetti_last';

  var lastFiredMemory = 0;

  function getLastFired() {
    try {
      var stored = Number(localStorage.getItem(STORE_KEY) || 0);
      return isNaN(stored) ? lastFiredMemory : Math.max(stored, lastFiredMemory);
    } catch (e) {
      return lastFiredMemory;
    }
  }

  function setLastFired(ts) {
    lastFiredMemory = ts;
    try {
      localStorage.setItem(STORE_KEY, String(ts));
    } catch (e) {}
  }

  function reducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function isConfirmButton(el) {
    if (!el) return false;

    /* Muss innerhalb des Bundle-Builders liegen – schützt vor Fehlauslösern. */
    if (!el.closest('[class*="bundle" i], [id*="bundle" i], [data-bundle-drawer]')) return false;

    if (el.matches(CONFIRM_SELECTOR)) return true;

    var label = (el.textContent || '').trim().toLowerCase();
    return CONFIRM_LABELS.indexOf(label) !== -1;
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('button, [role="button"], a');
    if (!isConfirmButton(el)) return;

    var now = Date.now();
    if (now - getLastFired() < COOLDOWN) return;
    setLastFired(now);

    if (reducedMotion()) return;

    setTimeout(burst, DELAY);
  }, true);

  function burst() {
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9998';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = canvas.width = window.innerWidth * dpr;
    var h = canvas.height = window.innerHeight * dpr;
    ctx.scale(dpr, dpr);

    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var count = vw < 700 ? 70 : 110;
    var pieces = [];

    for (var i = 0; i < count; i++) {
      pieces.push({
        x: vw * (0.25 + Math.random() * 0.5),
        y: vh * 0.45 + (Math.random() - 0.5) * 60,
        vx: (Math.random() - 0.5) * 9,
        vy: -7 - Math.random() * 9,
        size: 5 + Math.random() * 6,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.28,
        color: COLORS[(Math.random() * COLORS.length) | 0],
        round: Math.random() < 0.35
      });
    }

    var start = performance.now();
    var DURATION = 2600;

    function frame(now) {
      var elapsed = now - start;
      if (elapsed > DURATION) {
        canvas.remove();
        return;
      }

      var fade = elapsed > DURATION - 700 ? (DURATION - elapsed) / 700 : 1;
      ctx.clearRect(0, 0, w, h);
      ctx.globalAlpha = fade;

      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];

        p.vy += 0.32;        /* Schwerkraft */
        p.vx *= 0.992;       /* Luftwiderstand */
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        if (p.y > vh + 40) continue;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;

        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        }

        ctx.restore();
      }

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }
})();

/* ------------------------------------------------------------------
 * PINKYPACT – Size-Guide Deep-Link
 *
 * Link:  /products/press-on-starterset#sizeguide
 * Öffnet das Size-Guide-Collapsible und scrollt sticky-korrekt hin.
 *
 * Der Size Guide liegt zweimal im DOM: Desktop mit
 * id="block--collapsible_text_SizeG01", Mobile mit data-block-id und
 * ohne id. Deshalb wird die sichtbare Instanz gewählt statt der ersten.
 * Basiert auf dem Block-Key SizeG01 – überlebt Theme-Kopien und
 * Veröffentlichungen. Bricht nur, wenn der Block neu angelegt wird.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (window.__ppSizeGuideAnchor) return;
  window.__ppSizeGuideAnchor = true;

  var HASHES = ['sizeguide', 'size-guide', 'block--collapsible_text_SizeG01'];
  var SEL = '#block--collapsible_text_SizeG01, [data-block-id="collapsible_text_SizeG01"]';
  var STICKY = 'header, .header, [id*="announcement"], #tiktok-live-bar';
  var handled = '';

  function wanted() {
    return HASHES.indexOf((location.hash || '').replace(/^#/, '')) !== -1;
  }

  function isVisible(el) {
    return !!el && el.offsetParent !== null && el.getBoundingClientRect().height > 0;
  }

  /* Header, Announcement-Bar und TikTok-Live-Bar liegen übereinander –
     der Offset wird gemessen statt geraten. */
  function stickyOffset() {
    var total = 0;
    Array.prototype.forEach.call(document.querySelectorAll(STICKY), function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top > 120 || r.height === 0) return;
      total = Math.max(total, r.bottom);
    });
    return total;
  }

  function reveal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (!nodes.length) return false;

    var target = nodes.filter(isVisible)[0] || nodes[0];
    var details = target.matches('details') ? target : target.querySelector('details');

    if (details && !details.open) {
      details.open = true;
      details.setAttribute('aria-expanded', 'true');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    setTimeout(function () {
      var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }, 120);

    return true;
  }

  /* Der Bundle Builder rendert die Blöcke verzögert – daher Retry. */
  function run() {
    if (!wanted() || handled === location.hash) return;
    handled = location.hash;

    var tries = 0;
    (function attempt() {
      if (reveal()) return;
      if (++tries < 40) setTimeout(attempt, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  window.addEventListener('hashchange', run);
})();
